/**
 * GraphQL Query
 * 共通
 */

/**
 * sites
 */
export const GRAPH_QL_QUERY_SITES =
`
query {
  sites {
    code
    name
    type
    customerGroup {
      code
      name
    }
    paymentMethods {
      code
      name
      nameAbbr
      methodType
      isImmediatable
      isPoint
    }
  }
}
`

/**
 * serviceSiteConfigs
 */
export const GRAPH_QL_QUERY_SERVICE_SITE_CONFIGS =
`
query {
  serviceSiteConfigs (
    system: true
    sites: true
  ) {
    site {
      code
      name
    }
    key1
    key2
    key3
    value1
    value2
    value3
    displayValue
    displayAbbr
    displayOrder
  }
}
`

/**
 * searchConditions
 */
export const GRAPH_QL_QUERY_SEARCH_CONDITIONS =
`
query {
  searchConditions {
    uuid
    functionKey
    requestKey
    displayValue
    inputType
    isRequired
    valueType
    precision
    max
    min
    maxLength
    placeholder
    optionKey
    isAttribute
  }
}
`
/**
 * searchConditionConfigs
 */
export const GRAPH_QL_QUERY_SEARCH_CONDITION_CONFIG =
`
query {
  searchConditionConfigs (?) {
    edges{
      node {
        id
        uuid
        name
        functionKey
        account
        items {
          searchCondition {
            uuid
            requestKey
            displayValue
          }
          value
          updatedAt
        }
        updatedAt
      }
    }
  }
}
`

/**
 * displayItemConfigs
 */
export const GRAPH_QL_QUERY_DISPLAY_CONFIG =
`
query {
  displayItemConfigs (?) {
    edges{
      node {
        id
        uuid
        name
        functionKey
        account
        items {
          displayItem {
            uuid
            itemKey
            attributeDisplayName
            attributeProperty
            isDefaultDisplay
            displayOrder
          }
          updatedAt
        }
        updatedAt
      }
    }
  }
}
`

/**
 * displayItems
 */
export const GRAPH_QL_QUERY_DISPLAY_ITEMS =
`
query {
    displayItems (?) {
      uuid
      itemKey
      attributeDisplayName
      attributeProperty
      isDefaultDisplay
      displayOrder
    }
}
`



// WEBPACK FOOTER //
// ./src/queries/common.js